/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDPDC3tzztbbeupWxPfiWOE10JhN8iFC-E",
  authDomain: "vernikaai-production.firebaseapp.com",
  projectId: "vernikaai-production",
  storageBucket: "vernikaai-production.firebasestorage.app",
  messagingSenderId: "1020999369639",
  appId: "1:1020999369639:web:77d9ed41c90f411e43ac82",
  measurementId: "G-ZJ0N2LJMX8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;


